/*
 * PWT Search Enhancements (additive — does not modify theme.js)
 * - Zero-state: when a typed query returns no predictive product results, offer alternatives
 *   (popular searches + category links) instead of a blank dropdown.
 * No on-focus "empty state" panel — clicking the search box shows nothing until you type.
 * Hooks the native Motion predictive search DOM: #HeaderSearchForm / #PredictiveWrapper / #PredictiveResults
 */
(function () {
  'use strict';

  var CFG = {};
  try {
    var dataEl = document.getElementById('PwtSearchEnhanceData');
    if (dataEl) CFG = JSON.parse(dataEl.textContent || '{}');
  } catch (e) { CFG = {}; }
  var POPULAR = CFG.popular || [];
  var CATEGORIES = CFG.categories || [];

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function searchHref(term) {
    return '/search?q=' + encodeURIComponent(term) + '&type=product';
  }
  function chip(label, href) {
    return '<li class="pwt-se__chip"><a href="' + href + '">' + escapeHtml(label) + '</a></li>';
  }
  function section(label, itemsHtml) {
    if (!itemsHtml) return '';
    return '<div class="pwt-se__section"><p class="h6 predictive__label">' + label +
      '</p><ul class="pwt-se__list">' + itemsHtml + '</ul></div>';
  }
  function popularHtml() {
    return POPULAR.map(function (t) { return chip(t, searchHref(t)); }).join('');
  }
  function categoriesHtml() {
    return CATEGORIES.map(function (c) { return chip(c.label, c.url); }).join('');
  }

  function init() {
    var form = document.getElementById('HeaderSearchForm');
    if (!form) return;
    var input = form.querySelector('input[type="search"]');
    var wrapper = document.getElementById('PredictiveWrapper');
    var results = document.getElementById('PredictiveResults');
    if (!input || !wrapper || !results) return;

    var timer;
    var IGNORE = { 9: 1, 13: 1, 27: 1, 37: 1, 38: 1, 39: 1, 40: 1 }; // tab, enter, esc, arrows

    function showZero(q) {
      results.innerHTML = '<div class="pwt-se" data-pwt-state="zero">' +
        '<p class="pwt-se__none">No matches for &ldquo;' + escapeHtml(q) + '&rdquo;. Try one of these:</p>' +
        section('Popular searches', popularHtml()) +
        section('Shop', categoriesHtml()) +
        '</div>';
      wrapper.classList.remove('hide');
    }

    // After the user stops typing, give the native predictive fetch time to render, then — if it
    // produced no product results — show alternatives. Driven by keyup (not DOM mutations) so it
    // fires reliably even when the native dropdown was empty to begin with.
    input.addEventListener('keyup', function (e) {
      if (e.keyCode && IGNORE[e.keyCode]) return;
      clearTimeout(timer);
      var q = input.value.replace(/\*/g, '').trim();
      if (!q) return; // empty box: native hides the dropdown; we show nothing
      timer = setTimeout(function () {
        var cur = input.value.replace(/\*/g, '').trim();
        if (!cur) return;
        if (results.querySelector('.predictive__result')) return; // native has real results
        showZero(cur);
      }, 800);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
